/**
 * Frontend UI Effects
 * Maneja efectos de interfaz sin jQuery
 */

export class UIEffects {
    constructor() {
        this.isInitialized = false;
        this.init();
    }

    init() {
        if (this.isInitialized) return;

        this.setupCategoryHover();
        this.setupFilePreview();
        this.setupUserAgent();
        this.setupDownloadHandlers();
        this.isInitialized = true;

        console.log('Frontend UI Effects inicializados');
    }

    /**
     * Efectos hover para categorías (carpetas)
     */
    setupCategoryHover() {
        const categoryLinks = document.querySelectorAll('.cat-select a');

        categoryLinks.forEach(link => {
            const icon = link.querySelector('i.far.fa-folder, i.fas.fa-folder-open');
            if (!icon) return;

            link.addEventListener('mouseenter', () => {
                icon.classList.remove('far', 'fa-folder');
icon.classList.add('fas', 'fa-folder-open');
            });

            link.addEventListener('mouseleave', () => {
                icon.classList.remove('fas', 'fa-folder-open');
icon.classList.add('far', 'fa-folder');
            });
        });

        console.log(`Category hover effects aplicados a ${categoryLinks.length} elementos`);
    }

    /**
     * Preview de imagen para avatar
     */
    setupFilePreview() {
        const avatarInput = document.querySelector('#avatar');
        if (avatarInput) {
            avatarInput.addEventListener('change', (e) => {
                this.previewImage(e.target);
            });
            console.log('File preview configurado para #avatar');
        }

        // También configurar la función global para compatibilidad
        window.previewImage = this.previewImage.bind(this);
    }

    /**
     * Previsualizar imagen seleccionada
     */
    previewImage(input) {
        if (!input.files || !input.files[0]) return;

        const file = input.files[0];
        const preview = document.querySelector('#previewAvatar');

        if (!preview) {
            console.warn('Elemento #previewAvatar no encontrado');
            return;
        }

        // Validar tipo de archivo
        if (!file.type.startsWith('image/')) {
            console.error('El archivo seleccionado no es una imagen');
            return;
        }

        // Validar tamaño (opcional, máximo 5MB)
        const maxSize = 5 * 1024 * 1024; // 5MB
        if (file.size > maxSize) {
            console.error('La imagen es demasiado grande (máximo 5MB)');
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            preview.src = e.target.result;
            preview.style.opacity = '0';
            preview.style.transition = 'opacity 0.3s ease';

            // Fade in effect
            setTimeout(() => {
                preview.style.opacity = '1';
            }, 50);
        };

        reader.onerror = () => {
            console.error('Error al leer el archivo');
        };

        reader.readAsDataURL(file);
    }

    /**
     * Configuración de User Agent
     */
    setupUserAgent() {
        const body = document.body;
        if (body) {
            body.setAttribute('data-useragent', navigator.userAgent);

            // Agregar clases específicas del navegador
            const ua = navigator.userAgent.toLowerCase();

            if (ua.includes('chrome')) body.classList.add('browser-chrome');
            if (ua.includes('firefox')) body.classList.add('browser-firefox');
            if (ua.includes('safari') && !ua.includes('chrome')) body.classList.add('browser-safari');
            if (ua.includes('edge')) body.classList.add('browser-edge');

            // Detectar dispositivos móviles
            if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua)) {
                body.classList.add('mobile-device');
            }
        }
    }

    /**
     * Manejadores de descarga
     */
    setupDownloadHandlers() {
        // Event delegation para links de descarga
        document.addEventListener('click', (e) => {
            const downloadLink = e.target.closest('[data-download]');
            if (downloadLink) {
                e.preventDefault();
                this.handleDownload(downloadLink);
            }
        });

        // Función global para compatibilidad
        window.downloadFile = this.downloadFile.bind(this);
    }

    /**
     * Manejar descarga desde elemento con data attributes
     */
    handleDownload(element) {
        const tipo = element.dataset.tipo || element.dataset.type;
        const id = element.dataset.id;

        if (tipo && id) {
            this.downloadFile(tipo, id);
        }
    }

    /**
     * Función de descarga (mantiene compatibilidad)
     */
    downloadFile(tipo, id) {
        const currentLocale = this.getCurrentLocale();
        const baseUrl = window.base_url || window.location.origin;
        const downloadUrl = `${baseUrl}/${currentLocale}/home/download/${tipo}/${id}`;

        // Abrir en nueva pestaña/ventana
        window.open(downloadUrl, '_blank');

        console.log(`Descarga iniciada: ${tipo}/${id}`);
    }

    /**
     * Obtener locale actual
     */
    getCurrentLocale() {
        const path = window.location.pathname;
        const matches = path.match(/^\/?([a-z]{2})\//);
        return matches ? matches[1] : 'es';
    }

    /**
     * Efectos de hover generales
     */
    setupGeneralHoverEffects() {
        // Hover effects para botones
        const buttons = document.querySelectorAll('.btn, .button, button');

        buttons.forEach(button => {
            button.addEventListener('mouseenter', () => {
                button.style.transition = 'all 0.2s ease';
                button.style.transform = 'translateY(-1px)';
            });

            button.addEventListener('mouseleave', () => {
                button.style.transform = 'translateY(0)';
            });
        });
    }

    /**
     * Animaciones de entrada para elementos
     */
    animateOnScroll() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-in');
                }
            });
        }, {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        });

        // Observar elementos que pueden animarse
        const animatableElements = document.querySelectorAll('.pictures, .table tr, .cat-select');
        animatableElements.forEach(el => {
            observer.observe(el);
        });
    }

    /**
     * Smooth scroll para navegación
     */
    setupSmoothScroll() {
        const links = document.querySelectorAll('a[href^="#"]');

        links.forEach(link => {
            link.addEventListener('click', (e) => {
                const targetId = link.getAttribute('href').substring(1);
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    e.preventDefault();
                    targetElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        });
    }

    /**
     * Método para refrescar efectos UI
     */
    refresh() {
        this.isInitialized = false;
        this.init();
    }

    /**
     * Agregar clase de loading a un elemento
     */
    setLoading(element, isLoading = true) {
        if (isLoading) {
            element.classList.add('loading');
            element.style.opacity = '0.6';
            element.style.pointerEvents = 'none';
        } else {
            element.classList.remove('loading');
            element.style.opacity = '';
            element.style.pointerEvents = '';
        }
    }

    /**
     * Crear efecto de ripple en elementos
     */
    addRippleEffect(element) {
        element.addEventListener('click', (e) => {
            const ripple = document.createElement('span');
            const rect = element.getBoundingClientRect();
            const size = Math.max(rect.width, rect.height);
            const x = e.clientX - rect.left - size / 2;
            const y = e.clientY - rect.top - size / 2;

            ripple.style.cssText = `
                position: absolute;
                width: ${size}px;
                height: ${size}px;
                left: ${x}px;
                top: ${y}px;
                background: rgba(255, 255, 255, 0.3);
                border-radius: 50%;
                transform: scale(0);
                animation: ripple 0.6s ease-out;
                pointer-events: none;
            `;

            element.appendChild(ripple);

            setTimeout(() => {
                ripple.remove();
            }, 600);
        });
    }
}
